import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Chatbot from './components/Chatbot';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import TechnologyConsultingNewPage from './pages/TechnologyConsultingNewPage';
import AIConsultingPage from './pages/AIConsultingPage';
import ProductDevelopmentPage from './pages/ProductDevelopmentPage';
import WorkforceSolutionsPage from './pages/WorkforceSolutionsPage';
import ClientImpactPage from './pages/ClientImpactPage';
import WhyTekClapPage from './pages/WhyTekClapPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import CareersPage from './pages/CareersPage';
import JobDetailPage from './pages/JobDetailPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfUsePage from './pages/TermsOfUsePage';
import EqualOpportunityPage from './pages/EqualOpportunityPage';
import AIDisclaimerPage from './pages/AIDisclaimerPage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            {/* Homepage */}
            <Route path="/" element={<HomePage />} />
            
            {/* Services Overview */}
            <Route path="/services" element={<ServicesPage />} />
            
            {/* Core Service Pages - New SEO-optimized URLs */}
            <Route path="/technology-consulting" element={<TechnologyConsultingNewPage />} />
            <Route path="/ai-consulting" element={<AIConsultingPage />} />
            <Route path="/product-development" element={<ProductDevelopmentPage />} />
            <Route path="/workforce-solutions" element={<WorkforceSolutionsPage />} />
            
            {/* Legacy routes - redirect to new URLs */}
            <Route path="/services/technology-consulting" element={<TechnologyConsultingNewPage />} />
            <Route path="/services/product-ai-solutions" element={<AIConsultingPage />} />
            <Route path="/services/talent-workforce" element={<WorkforceSolutionsPage />} />
            
            {/* Trust & Conversion Pages */}
            <Route path="/client-impact" element={<ClientImpactPage />} />
            <Route path="/why-tekclap" element={<WhyTekClapPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            
            {/* Careers Pages */}
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/careers/:jobId" element={<JobDetailPage />} />
            
            {/* Legal & Compliance Pages */}
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-of-use" element={<TermsOfUsePage />} />
            <Route path="/equal-opportunity" element={<EqualOpportunityPage />} />
            <Route path="/ai-disclaimer" element={<AIDisclaimerPage />} />
          </Routes>
        </main>
        <Footer />
        <Chatbot />
      </BrowserRouter>
    </div>
  );
}

export default App;
